export const BE_TO_FE_INTERFACES = {
  Meta: {
    current_page: 'currentPage',
    last_page: 'lastPage',
    per_page: 'perPage',
    to: 'to',
    total: 'total',
  },
};
